import React from "react";
import { Outlet } from "react-router-dom";

const DMSDeviceMainComponent = () => {
  return <Outlet />;
};

export default DMSDeviceMainComponent;
